import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'react-emotion';
import presets from '../utils/presets';
import { toRem, toVW, fp } from '../utils/functions';

const InnerWrapper = ({ narrow, children, className }) => {
  // facepaint
  const wrapper = css(
    fp({
      maxWidth: `${toRem(presets.baselineGrid * (narrow ? 180 : 240))}`,
      margin: '0 auto',
      padding: [
        `0 ${toRem(presets.baselineGrid * 2)}`,
        `0 ${toRem(presets.baselineGrid * 3)}`,
        `0 ${toRem(presets.baselineGrid * 4)}`,
        `0 ${toVW(presets.baselineGrid * 8)}`,
        `0 ${toVW(presets.baselineGrid * 10)}`,
      ],
    })
  );

  return <div className={cx(wrapper, className)}>{children}</div>;
};

InnerWrapper.propTypes = {
  narrow: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default InnerWrapper;



// WEBPACK FOOTER //
// ./src/components/inner-wrapper.js